import { RcIcon, styled } from '@ringcentral/juno';

export const GenericErrorLinkIcon = styled(RcIcon)`
  vertical-align: middle;
  margin-left: 4px;
`;
